var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * SocialInstagram icon component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconSocialInstagram extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.2 23.1H17.9C20.8 23.1 23.1 20.8 23.2 18V6.2C23.2 3.3 20.8 1 18 1H6.2C3.3 1 1 3.3 1 6.2V17.9C1 20.8 3.4 23.1 6.2 23.1ZM2.5 6.2C2.5 4.1 4.2 2.5 6.2 2.5H18C20.1 2.5 21.7 4.2 21.7 6.2V18C21.7 20.1 20 21.7 18 21.7H6.2C4.1 21.7 2.5 20 2.5 18V6.2ZM7 12.1C7 14.9 9.3 17.2 12.1 17.2C14.9 17.2 17.2 14.9 17.2 12.1C17.2 9.3 14.9 7 12.1 7C9.3 7 7 9.3 7 12.1ZM8.5 12C8.5 10 10.1 8.4 12.1 8.4C14.1 8.4 15.7 10 15.7 12C15.7 14 14.1 15.6 12.1 15.6C10.1 15.6 8.5 14 8.5 12ZM17.0996 6.19961C17.0996 6.69961 17.4996 7.09961 17.9996 7.09961C18.5996 7.09961 18.9996 6.69961 18.9996 6.09961C18.9996 5.59961 18.5996 5.09961 17.9996 5.09961C17.4996 5.09961 17.0996 5.49961 17.0996 5.99961V6.09961V6.19961Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconSocialInstagram.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconSocialInstagram.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconSocialInstagram.prototype, "size", void 0);
if (customElements.get('cat-icon-social-instagram') === undefined) {
    customElements.define('cat-icon-social-instagram', BlocksIconSocialInstagram);
}
